import { render, staticRenderFns } from "./UsersListItem.vue?vue&type=template&id=91af9d2e"
import script from "./UsersListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersListItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports